<template>
    <div class="programme">
        <nav-igation class="nav white"></nav-igation>
        <div class="banner" :style="{ backgroundImage: `url(${require('../../image/' + imgRou +'parkBack.jpg')})` }">
            <h3> Regional economic development and industrial park construction solution </h3>
            <p>区域经济发展与工业园区建设解决方案</p>
            <div>
                <p>
                    <span>1</span>
                    产业园建设
                </p>
                <i></i>
                <p>
                    <span>2</span>
                    数字化招商
                </p>
                <i></i>
                <p>
                    <span>3</span>
                    安全生产
                </p>
                <i></i>
                <p>
                    <span>4</span>
                    企业选址
                </p>
            </div>
        </div>
        <div class="Option">
            <img src="@/image/t01.jpg" class="left" alt="">
            <div class="info">
                <h3>政府工业园建设解决方案</h3>
                <div>Government Industrial Park Construction <br> Solutions </div>
                <p>从用地规划、产业分析、数字招商平台搭建，到精准招商、入园企业服务提供全流程落地方案，以“专业、高效、务实”作为项目执行标准，打造优势园区生态。助力企业以最优成本、最高效率落地投产，助力政府获得精准匹配、企业优质的招商成果。
                </p>
                <div class="sork">01</div>
            </div>
        </div>
        <div class="Option OptionRight" style="background: #F5F5F5">
            <img src="@/image/t02.png" v-if="device == 'ipad' || device == 'm'" class="left" alt="">
            <div class="info">
                <h3>中云招商引资管理平台</h3>
                <div> Zhongyun Investment Management <br> Platform </div>
                <p>解决地方招商引资需求，依托海量数据积累，生成产业全景图，挖掘促进产业发展的价值资源，精准锁定招商线索和关键触达路径，高效对接优质企业，动态智配扶持政策，开展靶向招商。项目招后落地服务及检测，形成项目全程跟踪、随时调度、联动推进的良好机制和过程可追溯、实时可跟踪的全流程管理模式，实现数字化招商管理，全面提升招商引资及企业落地效率。
                </p>
                <div class="sork">02</div>
            </div>
            <img src="@/image/t02.png" v-if="device == ''" class="left" alt="">
        </div>
        <div class="Option">
            <img src="@/image/t03.png" class="left" alt="">
            <div class="info">
                <h3>小安云安全生产管理平台</h3>
                <div> Xiaoan Cloud Safety Production <br> Management Platform </div>
                <p>依托各级单位对危化安全生产的管理要求，搭建企业安全生产云平台，实现操作控制智能化、风险预警精准化、危险作业无人化、运维辅助远程化，提升安全生立管理的可预测、可管控水平。强化企业快速感知、实时监测、超前预警、动态优化、智能决策、联动处置、系统评估、全局协同能力，实现提质增效、消患固本，打造企业工业互联网新基础设施，为企业新发展注入新动能。
                </p>
                <div class="sork">03</div>
            </div>
        </div>
        <div class="Option OptionRight back1f" style="background: #1F1275">
            <img src="@/image/t04.png" v-if="device == 'ipad' || device == 'm'" class="left" alt="">
            <div class="info">
                <h3>企业选址服务</h3>
                <div> Enterprise location service </div>
                <p>依托企业选址需求，绘制企业详细画像，匹配性分析企业增产选址方向，提供定制化选址建议。全流程一对一服务，根据企业选址方向，生成企业项目简介，匹配查询园区空地情况，协助企业进行选址考察对接，为企业制定最优惠用地方案。企业拿地后提供管家式手续代办，助力企业高效投产。
                </p>
                <div class="sork">04</div>
            </div>
            <img src="@/image/t04.png" v-if="device == ''" class="left" alt="">
        </div>
        <div class="Option">
            <img src="@/image/t05.png" class="left" alt="">
            <div class="info" style="margin-top: 40px;">
                <h3>小仓云智能仓储</h3>
                <div> Xiaocangyun intelligent storage </div>
                <p>托市区内闲置中小型厂房，解决市区内个人、微小型企业及中小型物流企业货物存放问题，实现货品物资集中、分类、规范的统一管理。货物信息共享，配套货物定位、查找、录入的智能系统，便于客户自行取货。为个人、企业客户提供低个租赁服务场地的同时专注于物流货品的消防、防爆、消杀、应急安全管理，避免货品随意堆放所带来的安全隐患。
                </p>
                <div class="sork">05</div>
            </div>
        </div>
        <div>
            <Footer></Footer>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            device: '',
            imgRou: '',//图片引入端 默认pc 
        }
    },
    mounted() {
        var vw = window.screen.width
        if (vw <= 1224) {
            this.device = 'ipad'
            this.imgRou = 'i-'
        }
        if (vw <= 750) {
            this.device = 'm'
            this.imgRou = 'm-'
        }
    },
}
</script>
<style lang="scss" scoped>
.nav {
    position: fixed;
    left: 0;
    top: 0;
    background: #fff;
}

.Option {
    padding: 110px 15%;
    display: flex;

    .info {
        color: #000000;
        padding: 60px 0 0 60px;
        position: relative;

        .sork {
            opacity: 0.08;
            font-size: 200px;
            color: #2DA7E0;
            line-height: 160px;
            font-weight: 800;
            position: absolute;
            left: 65px;
            top: 0px;
        }

        h3 {
            font-size: 30px;
            font-weight: 500;
        }

        div {
            font-size: 18px;
            margin-top: 10px;
            color: #303133
        }

        p {
            font-size: 16px;
            line-height: 32px;
            margin-top: 50px;
            color: #606266;
        }
    }

    .left {
        width: 50%;
    }
}

.back1f {
    .info {
        margin-top: 50px;
        color: #FFFFFF;

        .sork,
        p,
        div {
            color: #FFFFFF;
        }
    }

}

.OptionRight {

    .info {
        padding: 60px 60px 0 0;

        .sork {
            left: 0;
        }
    }

}

.banner {
    width: 100%;
    height: 700px;
    background-image: url(../../image/parkBack.jpg);
    background-size: 100% 100%;
    display: flex;
    margin-top: 80px;
    flex-direction: column;

    h3,
    div,
    p {
        margin: 0 auto;
        width: 70%;
        text-align: center;
    }

    h3 {
        font-size: 28px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 50px;
        margin-top: 190px;
    }

    div {
        width: 50%;
        display: flex;
        margin-top: 60px;

        p {
            display: flex;
            width: auto;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 23px;

            span {
                display: block;
                width: 25px;
                height: 25px;
                font-size: 12px;
                color: #979797;
                border: 1px solid rgba(151, 151, 151, 1);
                text-align: center;
                line-height: 25px;
                border-radius: 50%;
                margin-right: 10px
            }

            ;
        }

        i {
            display: block;
            width: 1px;
            height: 22px;
            background: #D8D8D8;
        }
    }

    >p {
        font-size: 38px;
        font-weight: 800;
        color: #FFFFFF;
        line-height: 94px;
        letter-spacing: 4px;
        margin-top: 18px;
    }
}</style>


// WEBPACK FOOTER //
// src/pages/programme/index.vue